import styled from 'styled-components';
import Theme from '@adsk/alloy-react-theme';

export const StyledModalAlertMessageContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 12px;
`;

export const StyledModalIconContainer = styled.div`
  width: 20px;
  margin-right: 20px;
`;

export const StyledModalAlertText = styled.div`
  color: ${Theme.colors.charcoal700};
`;
